import Title from "../shared/Title";
import { Homepage } from "../../@types/lang";
import WhyUsFirst from "../../assets/images/whyus/why-us-first.jpg";
import WhyUsSecond from "../../assets/images/whyus/why-us-second.jpg";
import WhyUsThird from "../../assets/images/whyus/why-us-third.jpeg";

type props = {
  lang: Homepage;
};

const WhyUs = ({ lang }: props) => {
  return (
    <>
      <div className="px-6 lg:px-20 flex flex-col lg:flex-row gap-10">
        <div className="min-w-[300px] lg:min-w-[550px] h-full flex flex-col gap-4">
          <img
            src={WhyUsFirst}
            alt="why_us_info"
            loading="lazy"
            className="w-full h-full object-cover max-w-full lg:max-w-[518px] max-h-[250px]"
          />
          <div className="w-full flex md:flex-row flex-col items-center h-full gap-4">
            <img
              src={WhyUsSecond}
              alt="second"
              loading="lazy"
              className="w-full h-full object-cover max-w-full lg:max-w-[250px] max-h-[250px]"
            />
            <img
              src={WhyUsThird}
              alt="first"
              loading="lazy"
              className="w-full h-full object-cover max-w-full lg:max-w-[250px] max-h-[250px]"
            />
          </div>
        </div>
        <div className="flex flex-col space-y-4 mb-8 lg:mb-10">
          <div className="mb-6">
            <Title text={lang.why_us_title} type="p" />
          </div>

          {lang.why_us_details.map((detail) => (
            <div key={detail.id} className="flex flex-col gap-2">
              <h3 className="text-base lg:text-lg font-medium text-[#1E1E1E]">
                {detail.title}
              </h3>
              <p className="text-sm lg:text-base text-[#A0A0A0] font-normal text-left">
                {detail.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default WhyUs;
